export default __webpack_public_path__ + "static/media/campton-light.6598ea44.ttf";